"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forwardRef = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function forwardNameAndTag(name, render) {
    render.displayName = name;
    render.__KONTUR_REACT_UI__ = name;
    render.__KONTUR_ICON__ = true;
    return render;
}
function forwardRef(name, render) {
    return forwardNameAndTag(name, react_1.default.forwardRef(render));
}
exports.forwardRef = forwardRef;
